export class AbstractCachableStore {
    constructor(logger, cache) {
        this.logger = logger;
        this.cache = cache;
        this.dataResolved = false;
    }
    get data() {
        return this._data;
    }
    clearCache() {
        var _a;
        (_a = this.cache) === null || _a === void 0 ? void 0 : _a.removeItem(this.cacheKey);
    }
    async init(callback) {
        this.dataResolved = false;
        if (this.cache) {
            const cached = this.cache.getItem(this.cacheKey);
            if (cached) {
                return Promise.race([
                    this.decodeCached(cached, callback),
                    this.resolveDataAndUpdateCache(callback),
                ]);
            }
        }
        return this.resolveDataAndUpdateCache(callback);
    }
    async decodeCached(cached, callback) {
        try {
            const decoded = await this.decodeData(cached);
            if (!this.dataResolved) {
                this._data = decoded;
                callback === null || callback === void 0 ? void 0 : callback(this.data);
            }
        }
        catch (error) {
            this.logger.error('Error decoding value from cache', error);
        }
    }
    async resolveDataAndUpdateCache(callback) {
        this._data = await this.fetchData();
        callback === null || callback === void 0 ? void 0 : callback(this.data);
        this.dataResolved = true;
        try {
            if (this._data && this.cache) {
                this.cache.setItem(this.cacheKey, await this.encodeData(this._data));
            }
        }
        catch (error) {
            this.logger.error('Error updating cache', error);
        }
    }
    async decodeData(cached) {
        return JSON.parse(cached);
    }
    async encodeData(data) {
        return JSON.stringify(data);
    }
}
//# sourceMappingURL=abstract-cachable-store.js.map